var _g, _g2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#003636",
    stroke: "#003636",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.048
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M4,436.536v-313C4.024,97,25.528,75.496,52.064,75.464H508v313 c-0.024,26.536-21.528,48.04-48.064,48.072L4,436.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M504,79.472v309c-0.032,24.32-19.744,44.032-44.064,44.064H8v-309 c0.032-24.32,19.744-44.032,44.064-44.064H504 M512,71.472H52.064C23.312,71.472,0,94.776,0,123.528l0,0v317h459.936 c28.752,0,52.064-23.312,52.064-52.064l0,0V71.472z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 130.832,
    width: 512,
    height: 73.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.488,
    y: 261.896,
    style: {
      fill: "#999999"
    },
    width: 168.72,
    height: 23.408
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.fb5cbf3cba2fc771663eed6b590c2f25.svg";
export { ForwardRef as ReactComponent };